import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import AlumniNavigation from '../Inc/AlumniNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Input, AutoComplete, Empty, Modal, Spin, Button, Tabs, Row, Col, Tooltip, Icon, Menu, Collapse, Form, Select, Radio, DatePicker } from 'antd';
import { compose } from 'recompose';
import moment from 'moment';
import './profile.css';
import noawards from './noawards.png';
import ScoutingInfo from './ScoutingInfo';
import SocialMedia from './SocialMedia';
import ContactInfo from './ContactInformation';
import AddressInfo from './AddressInfo';
import Interest from './Interests';
import EducationalInfo from './EducationalInfo';
import MyAwardsComponent from '../Inc/AwardSections';
import HobbiesAndBusinessComponent from '../Inc/HobbiesAndBusiness';

import Skeleton from 'react-loading-skeleton';
import { history } from '../../container/History';
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;
const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;
const FormItem = Form.Item;
const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT

const customPanelStyle = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 7px 64px 0 rgb(0 0 0 / 7%)',
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
};

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

function renderTitle(title) {
  return (
    <span>
      {title}
    </span>
  );
}


class AlumniProfile extends Component {

  constructor(props) {
    super(props)
    this.state = {
      phoneNumber: '',
      email: '',
      PersonGUID: '',
      panelView: '',
      hideAlumniProfileInfo: false,
      alumniName: null,
      isLoadingBusinessAndHobbies: false
    }

  }



  componentDidMount = () => {
    let getPanelView = localStorage.getItem("panelView") ? JSON.parse(localStorage.getItem("panelView")) : "alumniTabView"
    this.setState({
      panelView: getPanelView
    })

    localStorage.setItem('lastlocation', 'alumniprofile')
    let PersonGUID = this.props.match.params.personGuid
    if (this.state.PersonGUID == "") {
      this.setState({
        PersonGUID: PersonGUID
      })
    }

    const { state } = this.props.location;

    if (state && state.state && (typeof state.state.hideAlumniProfileInfo === 'boolean' && state.state.hideAlumniProfileInfo) && state.state.alumniName != null) {
      this.setState({
        hideAlumniProfileInfo: true,
        alumniName: state.state.alumniName
      });
    } else {
      // Run the else block only if hideAlumniProfileInfo or alumniName is missing
      if (!state || !state.state || state.state.hideAlumniProfileInfo === undefined || state.state.alumniName === undefined) {
        this.props.actions.isadmin();
        // this.props.actions.getAlumniInfo(PersonGUID, this.props.isadmin ? "admin" : "alumni");
        this.props.actions.getNESARegistrations(PersonGUID);
        this.props.actions.getSAFRegistrations(PersonGUID);
        this.props.actions.getAlumniEagleInfo(PersonGUID);
        this.props.actions.getAwards(PersonGUID, 'alumni');
        this.props.actions.getNESAmembershiplevels();
        this.props.actions.getEagleInfo();
        this.props.actions.getSAFmembershiplevels();
        this.props.actions.getallscoutingassociations();
        this.props.actions.getAllAffinityGroups();
        this.props.actions.getAllLocalAwards();
        this.props.actions.getallcouncils();
        this.props.actions.getOccupations()
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
   
    // if(this.props.isadmin == true ) {
    //   localStorage.setItem("panelView", JSON.stringify("adminTabView"))
    // }
    // if(this.props.isspecialist === true ) {
    //   localStorage.setItem("panelView", JSON.stringify("specialistTabView"))
    // }
    // else if(this.props.isadmin == false || this.props.isspecialist === false ) {
    //   localStorage.setItem("panelView", JSON.stringify("alumniTabView"))
    // }
  }

  // renderMyLocalAwardsSection = () => {
  //   if (this.props.localAwards_Loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Local Awards..." />
  //   }
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Local Awards..." />
  //   }

  //   if(this.props.profileinfo && this.props.localAwards) {
  //      let awardResources = this.props.profileinfo.extendedProfile ? this.props.profileinfo.extendedProfile : this.props.profileinfo.extendedProfileAttributes

  //      let notfound = awardResources.some(attribute => attribute['attributeId'] == '24');

  //      if (!notfound) {
  //       return <Row className='width-100' type='flex' align='middle' justify='center'>
  //         <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //           <Col xs={24} sm={24} md={6} lg={6} xl={6}>
  //             <img className='memb-img' src="../noawards.png" />
  //           </Col>
  //           <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
  //             <Row type='flex' align='bottom' justify='center'>
  //               <span className='memb-exp'>No Awards Found!</span>
  //             </Row>
  //           </Col>
  //         </Col>
  //       </Row>
  //     }

  //      this.props.localAwards.sort((a,b) => {
  //       return a.name.localeCompare(b.name);
  //     })

  //     return awardResources.map((k, index) => {
  //       if (k.attributeId == '24') {
  //         return this.props.localAwards.map((j, index) => {
  //           if (k.attributeVal == j.name) {
  //             return (
  //               <div className='affinitiessection'>
  //                 <Row type='flex' justify='flex-start' align='middle'>
  //                   <Col span={20}>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                       <Col span={24}>
  //                         <span className='m-l-20 award-name'>{j.name}</span>
  //                       </Col>
  //                     </Row>
  //                   </Col>
                    
  //                 </Row>
  //               </div>)
  //           }
  //         })
  //       }
  //     })
  //   }
  // }

  // renderAwards = () => {
  //   if (this.props.awardsloading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Awards..." />
  //   }
  //   if (this.props.awards) {
  //     let award = this.props.awards.awards

  //     var distintic_awards = award.reduceRight(function (r, a) {
  //       r.some(function (b) { return a.name === b.name; }) || r.push(a);
  //       return r;
  //     }, []);
  //     if (distintic_awards.length == 0) {
  //       return <Row className='width-100' type='flex' align='middle' justify='center'>
  //         <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //           <Col xs={24} sm={24} md={6} lg={6} xl={6}>
  //             <img className='memb-img' src={noawards} />
  //           </Col>
  //           <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
  //             <Row type='flex' align='bottom' justify='center'>
  //               <span className='memb-exp'>No Awards Found!</span>
  //             </Row>
  //           </Col>
  //         </Col>
  //       </Row>
  //     } else {
  //       return distintic_awards.map((k, index) => {
  //         let imgurl = (k.imageFilePath == "" || k.imageFilePath == null) ? noawards : k.imageFilePath
  //         return (
  //           <Row type='flex' className='awardcontainer' justify='flex-start' align='middle'>
  //             <Col span={6} className='text-center'>
  //               <img src={imgurl} className='award-img' />
  //             </Col>
  //             <Col span={18}>
  //               <Row type='flex' justify='flex-start' align='middle'>
  //                 <Col span={24}>
  //                   <span className='award-name'>{k.name}</span>
  //                 </Col>
  //                 {/* <Col span={24}>
  //                 <span className='award-date'>{k.dateEarned}</span>
  //               </Col> */}
  //               </Row>
  //             </Col>
  //           </Row>)
  //       })
  //     }
  //   }
  // }

  // renderMyAffinityGroups = () => {
  //   if (this.props.affinities_loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />
  //   }
  //   if (this.props.affinities_loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Affinity Group..." />
  //   }
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />
  //   }
  //   let affinityResources;

  //   if(this.props.profileinfo && this.props.affinities) {
  //     let affinityResourcesAttribute = this.props.profileinfo.extendedProfileAttributes ? this.props.profileinfo.extendedProfileAttributes : [];
  //     let affinityResourcesExtended = this.props.profileinfo.extendedProfile ? this.props.profileinfo.extendedProfile : [];

  //     if (affinityResourcesAttribute.length > 0) {
  //       affinityResources = this.props.profileinfo.extendedProfileAttributes;
  //     }else if(affinityResourcesExtended.length > 0){
  //       affinityResources = this.props.profileinfo.extendedProfile;
  //     }else{
  //       let notfound = affinityResourcesExtended.some(attribute => attribute['attributeId'] == '22')
  //       if (!notfound) {
  //         return <Empty className='width-100 text-center' description={
  //           <span>
  //             No Affinities Found! 
  //           </span>
  //         } image={Empty.PRESENTED_IMAGE_DEFAULT} />
  //       }
  //     }
      

  //   this.props.affinities.sort((a,b) => {
  //     return a.name.localeCompare(b.name);
  //   })

  //   return affinityResources.map((k, index) => {
  //     if (k.attributeId == '22') {
  //       return this.props.affinities.map((j, index) => {
  //         if (k.attributeVal == j.name) {
  //           let imgurl = (j.logo == "" || j.logo == null) ? "../nonationalassociation.png" : j.logo
  //           return (
  //             <div className='affinitygroups'>
  //               <Row type='flex' className='affinitiessection' justify='flex-start' align='middle'>
  //                 <Col span={9} className='text-center'>
  //                   <img src={imgurl} className='award-img' />
  //                 </Col>
  //                 <Col span={13}>
  //                   <Row type='flex' justify='flex-start' align='middle'>
  //                     <Col span={24}>
  //                       <span className='award-name'>{j.name}</span>
  //                     </Col>
  //                   </Row>
  //                 </Col>
  //               </Row>
  //             </div>)
  //         }
  //       })
  //     }
  //   })

  //   }
  // }

  getSAFreg = () => {
    if (this.props.saf_reg && this.props.saflevels) {
      let safreg = this.props.saf_reg
      let saflevels = this.props.saflevels
      let Membership_ID = ''
      let Membership_Name = ''
      let expireDate = ''
      let ActiveMembership = false
      if (safreg.length != 0 && safreg != 'error') {
        safreg.map((k, index) => {
          if (k.isActive === true) {
            ActiveMembership = true
            Membership_ID = k.programId
            expireDate = k.expireDate
            saflevels.map((j, index) => {
              if (parseInt(j.id) == Membership_ID) {
                Membership_Name = j.name
              }
            })
          }
        })
        if (ActiveMembership) {
          return <Row className='width-100' type='flex' align='middle' justify='center'>
            <Col className='center align-center' xs={24} sm={24} md={24} lg={24} xl={24}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src="../../../saf_logo.jpg" />
              </Col>
              <Col xs={24} sm={24} md={18} lg={18} xl={18} >
                <span className='memb-name'>{Membership_Name.replace(/-/g, " ")}</span> <br />
                <span className='memb-exp'>Expires {expireDate ? moment(expireDate).format('MM/DD/YYYY') : "-"}</span>
              </Col>
            </Col>
          </Row>
        } else {
          return <Row className='width-100' type='flex' align='middle' justify='center'>
            <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src="../../../no_saf.jpg" />
              </Col>
              <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
                <Row type='flex' align='bottom' justify='center'>
                  <span className='memb-exp'>No SAF Records Found!</span>
                </Row>
              </Col>
            </Col>
          </Row>
        }
      } else {
        return <Row className='width-100' type='flex' align='middle' justify='center'>
          <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <img className='memb-img' src="../../../no_saf.jpg" />
            </Col>
            <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
              <Row type='flex' align='bottom' justify='center'>
                <span className='memb-exp'>No SAF Records Found!</span>
              </Row>
            </Col>
          </Col>
        </Row>
      }
    } else {
      return <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Spin indicator={antIcon} tip='loading SAF Records!' />
        </Col>
      </Row>
    }
  }

  getNESAreg = () => {
    if (this.props.nesa_reg && this.props.nesa_levels) {
      let nesareg = this.props.nesa_reg
      let nesalevels = this.props.nesa_levels
      let Membership_ID = ''
      let Membership_Name = ''
      let expireDate = ''
      let ActiveMembership = false
      if (nesareg.length != 0 && nesareg != 'error') {
        nesareg.map((k, index) => {
          if (k.isActive === true) {
            ActiveMembership = true
            Membership_ID = k.programId
            expireDate = k.expireDate
            nesalevels.map((j, index) => {
              if (parseInt(j.id) == Membership_ID) {
                Membership_Name = j.name
              }
            })
          }
        })
        if (ActiveMembership) {
          return <Row type='flex' align='middle' justify='center'>
            <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src="../../../NESA.png" />
              </Col>
              <Col xs={24} sm={24} md={18} lg={18} xl={18} >
                <Row type='flex' align='middle' justify='center'>
                  <span className='memb-name'>{Membership_Name.replace(/-/g, " ")}</span> <br />
                  <span className='memb-exp'>Expires {expireDate ? moment(expireDate).format('MM/DD/YYYY') : "-"}</span>
                </Row>
              </Col>
            </Col>
          </Row>
        } else {
          return <Row className='width-100' type='flex' align='middle' justify='center'>
            <Col className='center flex-baseline' xs={24} sm={24} md={24} lg={24} xl={24}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src="../../../no_nesa.png" />
              </Col>
              <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
                <Row type='flex' align='bottom' justify='center'>
                  <span className='memb-exp'>No NESA Records Found!</span>
                </Row>
              </Col>
            </Col>
          </Row>
        }

      } else {
        return <Row className='width-100' type='flex' align='middle' justify='center'>
          <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <img className='memb-img' src="../../../no_nesa.png" />
            </Col>
            <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
              <Row type='flex' align='bottom' justify='center'>
                <span className='memb-exp'>No NESA Records Found!</span>
              </Row>
            </Col>
          </Col>
        </Row>
      }
    } else {
      return <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Spin indicator={antIcon} tip='loading NESA Records!' />
        </Col>
      </Row>
    }
  }


  address = () => {
    const {isadmin} = this.props;
    if (!this.props.profileinfo || this.props.loading) {
      return <Skeleton width={200} />
    } else if ((isadmin || (this.props.privacysettingsOptions && this.props.privacysettingsOptions.isCityStateZipDisplayed)) && (Array.isArray(this.props.profileinfo.addresses) && this.props.profileinfo.addresses.length != 0)) {
      let getAddress;
      let personaddress = this.props.profileinfo.addresses.filter((data) => (typeof data.isPrimary === "string" && data.isPrimary.toLowerCase() === "true") || (typeof data.isPrimary === "boolean" && data.isPrimary))[0];
      if (personaddress){
        if (personaddress.countryId && personaddress.countryId === 616 ) {
          let city = personaddress.city ? personaddress.city : personaddress.primaryCity ? personaddress.primaryCity : '' 

          let state = personaddress.state ? personaddress.state : personaddress.primaryState ? personaddress.primaryState : '' 
          getAddress = `${city}${state.length ? `, ${state}` : ''}`;
        } else{
          getAddress = personaddress.address3 ? personaddress.address3 : 
          personaddress.addressLine3 ? personaddress.addressLine3 : ''
        }
        return (<span> <i className="fa fa-map-marker"></i> {getAddress} </span> );
      }
      return (<span> <i class='fa fa-map-marker'></i> N/A </span>)
    } else if((this.props.privacysettingsOptions && !this.props.privacysettingsOptions.isCityStateZipDisplayed)){
      return <span> <i className="fa fa-map-marker"></i> <i className="fa fa-lock masked-icon" aria-hidden="true"></i></span>
    } else{
      return (<span> <i class='fa fa-map-marker'></i> </span>)
    }
  }

  name = () => {
    const {isadmin} = this.props;
    if (this.props.loading) {
      return <Skeleton width={200} />
    }
    else if (!this.props.profileinfo || this.props.loading) {
      return <Skeleton width={200} />
    } else if ((isadmin || (this.props.privacysettingsOptions && this.props.privacysettingsOptions.isNameDisplayed)) && this.props.profileinfo) {
      console.log("Environment Variables ", process.env);

      console.log('Environment Name', REACT_APP_ENVIRONMENT);
      let firstName = '';
      let middleName = '';
      let lastName = '';
      let nameSuffix = '';
      let profileInfo = this.props.profileinfo;
      if (profileInfo) {
        if (this.props.isAdmin && profileInfo.profile) {
          firstName = profileInfo.profile.firstName || '';
          middleName = profileInfo.profile.middleName || '';
          lastName = profileInfo.profile.lastName || '';
          nameSuffix = profileInfo.profile.nameSuffix || '';
        } else {
          firstName = profileInfo.firstName || '';
          middleName = profileInfo.middleName || '';
          lastName = profileInfo.lastName || '';
          nameSuffix = profileInfo.nameSuffix || '';
        }
        const fullName = `${firstName} ${middleName} ${lastName} ${nameSuffix}`.trim();
        return fullName || (profileInfo && profileInfo.profile && profileInfo.profile.fullName) || '';
      }
    } else if(!isadmin && (this.props.privacysettingsOptions && !this.props.privacysettingsOptions.isNameDisplayed)) {
      return <span> <i className="fa fa-lock masked-icon" aria-hidden="true"></i> </span>;
    } 
    else {
      return <Skeleton width={200} />
    }  
  }

  checkIsDeceased = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={100} />
    }   
    else{
      const { profile } = this.props.profileinfo || {};
      const { isDeceased } = profile || this.props.profileinfo;

      return isDeceased ? " - Deceased" : '';
    }
  }

  email = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    } 
    else if ((this.props.isadmin || (this.props.privacysettingsOptions && this.props.privacysettingsOptions.isEmailDisplayed)) && (Array.isArray(this.props.profileinfo.emails) && this.props.profileinfo.emails.length != 0) ) {
      let personemail = this.props.profileinfo.emails.filter(data => (typeof (data.isPrimary) === "string" && data.isPrimary.toLowerCase() === "true" || typeof (data.isPrimary) === "boolean" && data.isPrimary))[0]
      if (personemail) {
        return (<span> <i class='fa fa-envelope'></i> {personemail.email} </span>)
      }
      return (<span> <i class='fa fa-envelope'></i> N/A </span>) // <Skeleton width={200} />
    }
    else if ((this.props.privacysettingsOptions && !this.props.privacysettingsOptions.isEmailDisplayed)) {
      return <span> <i className="fa fa-envelope"></i> <i className="fa fa-lock masked-icon" aria-hidden="true"></i></span>;
    }
    else {
      return (<span> <i class='fa fa-envelope'></i> </span>)
    }
  }

  phone = () => {
    const {isadmin} = this.props;
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    } else if((isadmin || (this.props.privacysettingsOptions && this.props.privacysettingsOptions.isTelephoneDisplayed)) && (Array.isArray(this.props.profileinfo.phones) && this.props.profileinfo.phones.length != 0)){
      let personphone = this.props.profileinfo.phones.filter(data => ((typeof(data.isPrimary) === "string" && data.isPrimary.toLowerCase() === "true") || typeof(data.isPrimary) === "boolean" && data.isPrimary))[0];
      let phoneNumber;
      if (personphone) {
        const countryCode = personphone.countryCode ? personphone.countryCode.replace(/^0+/, '') : "--";
        if(personphone.country && personphone.country === "USA") {
          const areaCode = personphone.areaCode ? personphone.areaCode : '';
          const prefix = personphone.prefix ? personphone.prefix : '';
          const lineNumber = personphone.lineNumber ? personphone.lineNumber : '';
          phoneNumber = `${countryCode} ${areaCode} ${prefix} ${lineNumber}`
        } else {
          let areaCode = personphone.areaCode ? personphone.areaCode : ''
          let prefix = personphone.prefix ? personphone.prefix : ""
          let lineNumber = personphone.lineNumber ? personphone.lineNumber : ""
          const truncatedphoneNumber = personphone.fullPhoneNumber ? personphone.fullPhoneNumber.substr(personphone.fullPhoneNumber.indexOf(' ')+1) : `${areaCode} ${prefix} ${lineNumber}`;
          const trimmedNumber = truncatedphoneNumber.trim().replace(/^0+/, '');
          phoneNumber = `${countryCode} ${trimmedNumber}`
        }
         
        return (<span> <i class='fa fa-phone'></i> {phoneNumber ? ` +${phoneNumber}` : ""} </span>)
      }
      return (<span> <i class='fa fa-phone'></i> N/A </span>) //<Skeleton width={200} />
    } else if ((this.props.privacysettingsOptions && !this.props.privacysettingsOptions.isTelephoneDisplayed)) {
      return <span> <i className="fa fa-phone"></i> <i className="fa fa-lock masked-icon" aria-hidden="true"></i></span>;
    }
    else{
      return (<span> <i class='fa fa-phone'></i> </span>)
    }
  } 

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  renderProfileImg = () => {
    if (!this.props.profileinfo || this.props.pic_updating) {
      return <Spin indicator={LoadingIcon} className='profile-img flex-center' />
    }
    else {
      console.log('Environment Checking', REACT_APP_ENVIRONMENT);
      let profile = this.props.profileinfo;
      let imgurl = profile && profile.profile &&  profile.profile.pictureUrl ? profile.profile.pictureUrl : profile && profile.pictureUrl ? profile.pictureUrl : '';
      if (imgurl == "" || imgurl == null) imgurl = "../../profileimage.png"
      return <img src={imgurl} className='profile-img' />
    }
  }

  renderAlumniInfo = (profileinfo) => {
    return (
      <p className='widget-content-section'>
        <Row className='next-row' type='flex' justify='space-between'>
          <Col xs={22} sm={22} md={8} lg={8} xl={8}>
            <Row type='flex' align='middle'>
              <label className='field-label'> PREFIX </label>
              <label className='field-value'> {profileinfo.profile.title} </label>
            </Row>
          </Col>
          <Col xs={22} sm={22} md={8} lg={8} xl={8}>
            <Row type='flex' align='middle'>
              <label className='field-label'> FIRST NAME </label>
              <label className='field-value'> {profileinfo.profile.firstName} </label>
            </Row>
          </Col>
          <Col xs={22} sm={22} md={8} lg={8} xl={8}>
            <Row type='flex' align='middle'>
              <label className='field-label'> MIDDLE NAME </label>
              <label className='field-value'> {profileinfo.profile.middleName} </label>
            </Row>
          </Col>
        </Row>
        <Row className='next-row'>
          <Col xs={22} sm={22} md={8} lg={8} xl={8}>
            <Row type='flex' align='middle'>
              <label className='field-label'> LAST NAME </label>
              <label className='field-value'> {profileinfo.profile.lastName} </label>
            </Row>
          </Col>
          <Col xs={22} sm={22} md={8} lg={8} xl={8}>
            <Row type='flex' align='middle'>
              <label className='field-label'> SUFFIX </label>
              <label className='field-value'> {profileinfo.profile.nameSuffix} </label>
            </Row>
          </Col>
          <Col xs={22} sm={22} md={8} lg={8} xl={8}>
            <Row type='flex' align='middle'>
              <label className='field-label'> NICK NAME </label>
              <label className='field-value'> {profileinfo.profile.nickName} </label>
            </Row>
          </Col>
        </Row>
      </p>
    )
  }

  rendermyeaglecouncil = () => {
    if (this.props.eagleinfo) {
      if (Object.keys(this.props.eagleinfo).length !== 0) {
        if (this.props.eagleinfo.eagleCouncilName != '') {
          let eagleCouncil = ''
          if (this.props.eagleinfo.eagleCouncilName) {
            eagleCouncil = this.props.eagleinfo.eagleCouncilName.replace(/ *\([^)]*\) */g, "")
          }
          return (
            <div className='scoutingaffiliations'>
              <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
                <Col span={20}>
                  <Row type='flex' justify='flex-start' align='middle'>
                    <Col span={24}>
                      <span className='m-l-20 award-name'>{eagleCouncil}</span>
                    </Col>
                  </Row>
                </Col>
                <Col span={2}>
                  <img className="eagle-logo" src='../../eagle-scout.png' />
                </Col>
              </Row>
            </div>)
        }
      }
    }
  }

  // renderCouncilAffiliations = () => {
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Council Affliations..." />
  //   }
  //   if (this.props.profileinfo && this.props.eagleinfo) {
  //     let councillookups; let eagleCouncil = '';
  //     // this.props.isadmin ? councillookups = this.props.profileinfo.extendedProfile : councillookups = this.props.profileinfo.extendedProfileAttributes
  //     // QA returns extendedProfileAttributes object for both admin and alumni

  //     // if (this.props.isadmin && ((REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'QA') || (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'development'))) {
  //     //   councillookups = this.props.profileinfo.extendedProfileAttributes;
  //     // }else if (this.props.isadmin && !((REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'QA') || (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'development'))) {
  //     //   councillookups = this.props.profileinfo.extendedProfile
  //     // }else if (!this.props.isadmin) {
  //     //   councillookups = this.props.profileinfo.extendedProfileAttributes
  //     // }

  //     if (this.props.profileinfo.extendedProfileAttributes) {
  //       councillookups = this.props.profileinfo.extendedProfileAttributes;
  //     }else if(this.props.profileinfo.extendedProfile){
  //       councillookups = this.props.profileinfo.extendedProfile
  //     }
  //     let notfound = councillookups.some(attribute => attribute['attributeId'] == '21')
  //     if (this.props.eagleinfo.eagleCouncilName) {
  //       eagleCouncil = this.props.eagleinfo.eagleCouncilName.replace(/ *\([^)]*\) */g, "")
  //     }
  //     if (!notfound && this.props.eagleinfo.eagleCouncilName == undefined) {
  //       return <Empty className='width-100 text-center' description={
  //         <span>
  //           No Records Found!
  //         </span>
  //       } image={Empty.PRESENTED_IMAGE_DEFAULT} />
  //     }
  //     return councillookups.map((k, index) => {
  //       if (k.attributeId == '21') {
  //         if (eagleCouncil == k.attributeVal) {
  //           return false
  //         }
  //         return (
  //           <div className='scoutingaffiliations'>
  //             <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //               <Row type='flex' className='width-100' justify='flex-start' align='middle'>
  //                 <Col span={22}>
  //                   <span className='award-name m-l-20'>{k.attributeVal}</span>
  //                 </Col>
  //               </Row>
  //             </Row>
  //           </div>)
  //       }
  //     })
  //   }
  // }

  // renderscoutingaffiliations = () => {
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Scouting Affliations..." />
  //   }
  //   if (this.props.profileinfo && this.props.scoutings) {
  //     let scoutingresources;
  //     // this.props.isadmin ? scoutingresources = this.props.profileinfo.extendedProfile : scoutingresources = this.props.profileinfo.extendedProfileAttributes;

  //     // if (this.props.isadmin && ((REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'QA') || (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'development'))) {
  //     //   scoutingresources = this.props.profileinfo.extendedProfileAttributes;
  //     // }else if (this.props.isadmin && !((REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'QA') || (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'development'))) {
  //     //   scoutingresources = this.props.profileinfo.extendedProfile
  //     // }else if (!this.props.isadmin) {
  //     //   scoutingresources = this.props.profileinfo.extendedProfileAttributes
  //     // }

  //     if (this.props.profileinfo.extendedProfileAttributes) {
  //       scoutingresources = this.props.profileinfo.extendedProfileAttributes;
  //     }else if(this.props.profileinfo.extendedProfile) {
  //       scoutingresources = this.props.profileinfo.extendedProfile;
  //     }

  //     let notfound = scoutingresources.some(attribute => attribute['attributeId'] == '20') 
  //     if (!notfound) {
  //       return <Empty className='width-100 text-center' description={
  //         <span>
  //           No Records Found!
  //         </span>
  //       } image={Empty.PRESENTED_IMAGE_DEFAULT} />
  //     }
  //     return scoutingresources.map((k, index) => {
  //       if (k.attributeId == '20') {
  //         return this.props.scoutings.map((j, index) => {
  //           if (k.attributeVal == j.name) {
  //             let imgurl = (j.logo == "" || j.logo == null) ? "../nonationalassociation.png" : j.logo
  //             return (
  //               <div className='scoutingaffiliations'>
  //                 {/* <Row className='affinityIcons' type='flex' align='bottom' justify='end'>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Love">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/love.png")} onMouseOver={e => (e.currentTarget.src = "/h-love.png")} className='pointer' src='/love.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Volunteer">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/volunteer.png")} onMouseOver={e => (e.currentTarget.src = "/h-volunteer.png")} className='pointer' src='/volunteer.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Camp">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/camp.png")} onMouseOver={e => (e.currentTarget.src = "/h-camp.png")} className='pointer' src='/camp.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Donate">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/dollar.png")} onMouseOver={e => (e.currentTarget.src = "/h-dollar.png")} className='pointer' src='/dollar.png' />
  //                 </Tooltip>
  //               </Col>
  //             </Row>
  //             */}
  //                 <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //                   <Col span={6} className='text-center'>
  //                     <img src={imgurl} className='award-img' />
  //                   </Col>
  //                   <Col span={18}>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                       <Col span={24}>
  //                         <span className='award-name'>{j.name}</span>
  //                       </Col>
  //                       {/* <Col span={24}>
  //                 <span className='award-date'>{k.dateEarned}</span>
  //               </Col> */}
  //                     </Row>
  //                   </Col>
  //                 </Row>
  //               </div>)
  //           }
  //         })
  //       }
  //     })
  //   }
  // }

  
  rendereagleflag = () => {
    if (this.props.profileinfo) {

      let isEagleFlag;
      
      if(this.props.admin) {
        if ((REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'development')){
          isEagleFlag = this.props.profileinfo.isEagle;
        }else{
          isEagleFlag = this.props.profileinfo.profile.isEagle
        }
      }else{
        isEagleFlag = this.props.profileinfo.isEagle;
      }

      if (isEagleFlag)
        return <img className="eagle-logo" src='../../eagle-scout.png' />
      }
  }


  renderWebContacts = () => {
    if (this.props.profileinfo) {
      let webcontacts;
      if (this.props.isadmin) {
        let profile = this.props.profileinfo
        webcontacts = profile.webContacts
      } else {
        webcontacts = this.props.profileinfo.webContacts
      }
      if (webcontacts.length != 0) {
        return webcontacts.map((k, index) => {
          if (k.typeId == "14") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank" rel="noopener noreferrer"><svg
                          width="19"
                          height="19"
                          viewBox="0 0 1200 1227"
                          fill="currentColor"
                          style={{
                            // verticalAlign: "middle",
                            marginRight: "10px",
                            color: "white"
                          }}
                          aria-hidden="true"
                        >
                          <path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" />
                        </svg>
                        </a>
          }
          if (k.typeId == "15") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><i className="fa fa-facebook-square margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
          if (k.typeId == "17") {
            return <a href={"https://" + k.type + ".com/in/" + k.address} target="_blank"><i className="fa fa-linkedin-square margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
          if (k.typeId == "19") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><i className="fa fa-instagram margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
        })
      }
    }
  }




  render() {
    const {isadmin} = this.props;
    return (
      <div>
        <LayoutHeader />

        {( (this.props.isadmin == true &&  this.state.panelView === 'adminTabView') || (this.props.isspecialist === true && this.state.panelView === 'specialistTabView' ) ) &&
          <AdminNavigation />
        }

        {(this.state.panelView === 'alumniTabView')  &&
          <AlumniNavigation />
        }
        <div className='my-profile alumn-profile'>
          <Row type="flex" justify="center">
            <Col xs={22} sm={22} md={22} lg={20} xl={20}>
              <Row>
                <Col span={12}>
                  <span className="text-result pointer" onClick={() => {
                    let splitPath = this.props.location.pathname.split('/');
                    let getPath = splitPath.at(-1)
                    // const isUrlQuickSearch = window.location.pathname.includes('/quick-search');
                    // if(isUrlQuickSearch === true){
                    //   history.push('/quick-search')
                    // }else{
                    //   history.push('/alumni-search')
                      const isAlumniViewPath = window.location.pathname.includes('/alumni-search') || window.location.pathname.includes('/advanced-search');

                      const isAdminViewPath = window.location.pathname.includes('/quick-search') || window.location.pathname.includes('/list-and-search');

                      if (isAlumniViewPath) {
                        localStorage.setItem("panelView", JSON.stringify("alumniTabView"));
                        sessionStorage.setItem('scrollToId', 'alumni-search-results');
                      }else if(isAdminViewPath){
                        localStorage.setItem("panelView", JSON.stringify("adminTabView"));
                      }
                      history.push(`/${getPath}`)
                      // const isMaintainPath = window.location.pathname.includes('/maintain-alumni');
                    // }
                  }}><i class="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Search Results</span>
                </Col>
                <Col span={24}>
                  <div className=''>
                    <div className='profile-content'>
                      <div className='bg-banner'>
                        <Row type="flex" justify="end" align='middle'>
                          <div className='m-h-60'>
                            <span className='connectwithme'> Connect with Me </span>
                            {(this.props.profileinfo && this.props.profileinfo.webContacts.length != 0) &&
                              (isadmin || (this.props.privacysettingsOptions && this.props.privacysettingsOptions.isWebContactsDisplayed)) ? this.renderWebContacts()
                              : <span><i className="fa fa-lock margin-right-10 fa-2x white pointer" aria-hidden="true"></i></span>
                            }
                          </div>
                        </Row>
                        {/* {this.state.hideAlumniProfileInfo ? 
                        <Row type="flex" justify="start" align='middle'>
                          <Col md={7} lg={6} xl={3}>
                            {<img src='../../profileimage.png' className='profile-img' /> }
                          </Col>
                          <Col className='m-l-25' md={15} lg={16} xl={17}>
                            <span className='text'>{this.state.alumniName ? this.state.alumniName : '*****'}</span>
                            <span className='textdesc'> <span> <i class='fa fa-envelope'></i> ***** </span> </span>
                              <span className='textdesc'> <span> <i class='fa fa-phone'></i> ***** </span> </span>
                            <span className='textdesc'> <span> <i class='fa fa-map-marker'></i> ***** </span> </span>
                          </Col>
                          </Row>
                        : */}
                         <Row type="flex" justify="start" align='middle'>
                          <Col md={5} lg={5} xl={3}>
                            {this.renderProfileImg()}
                          </Col>
                          <Col md={17} lg={17} xl={17}>
                            <div style={{ padding: '0px 0px 7px 0px' }}>
                              <span className='text' style={{display: 'inline'}}>{this.name()}</span>
                              <span className='breadcrums'>{this.checkIsDeceased()}</span>
                            </div>
                            <span className='textdesc'> {this.email()} </span>
                              <span className='textdesc'> {this.phone()} </span>
                            <span className='textdesc'> {this.address()} </span>
                          </Col>
                          <Col md={2} lg={2} xl={2}>
                            <div className='text-right'> {this.rendereagleflag()} </div>
                          </Col>
                        </Row>
                        {/* } */}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            
            {/* <Col xs={22} sm={22} md={22} lg={20} xl={20}>
            <div className='alumni-dashboard-info'>

              <div className='scouting-affiliations gutter-row'>
              <div className='container min-height-550'>
                  <div className='widget-content'>  
                      <div className='widget-header-text'>
                        My Scouting Affiliations
                      </div>
                    <div className='widget-content-section'>
                        {this.renderscoutingaffiliations()}
                    </div>
                  </div>
                </div>
              </div>

              <div className='council-affiliations gutter-row'>
              <div className='container min-height-550'>
                  <div className='widget-content'>  
                      <div className='widget-header-text'>
                        My Council Affiliations
                      </div>
                    <div className='widget-content-section'>
                      {this.rendermyeaglecouncil()}
                      {this.renderCouncilAffiliations()}
                    </div>
                  </div>
                </div>
              </div>

              <div className='affinity-groups gutter-row'>
              <div className='container min-height-550'>
                  <div className='widget-content'>  
                      <div className='widget-header-text'>
                        My Affinity Groups
                      </div>
                    <div className='widget-content-section'>
                        {this.renderMyAffinityGroups()}   
                  </div>
                </div>
                </div>
              </div>

              <div className='award-section gutter-row'>
              <div className='container min-height-550'>
                  <div className='widget-content'>  
                      <div className='widget-header-text'>
                          My National Awards
                      </div>
                    <div className='widget-content-section'>
                          {this.renderAwards()}
                    </div>
                  </div>
                </div>
              </div>

              <div className='localaward-section gutter-row'>
              <div className='container min-height-550'>
                  <div className='widget-content'>  
                      <div className='widget-header-text'>
                          My Local Awards
                      </div>
                    <div className='widget-content-section'>
                          {this.renderMyLocalAwardsSection()}
                    </div>
                  </div>
                </div>
              </div>
              </div>      
            </Col> */}
          </Row>



          {(!this.state.hideAlumniProfileInfo && this.state.alumniName === null) && <MyAwardsComponent forAlumniProfile={true} />}
          {(!this.state.hideAlumniProfileInfo && this.state.alumniName === null) && <HobbiesAndBusinessComponent forAlumniProfile={true} eagleInfo={this.props.eagleinfo} />}
        </div>

      </div>
    );
  }
}



function mapStateToProps(state) {
  return {
    profileinfo: state.alumniinforeducer.profileinfo,
    loading: state.alumniinforeducer.loading,
    isadmin: state.isadminreducer.isadmin,
    saf_loading: state.safregistrationreducer.loading,
    saf_reg: state.safregistrationreducer.reg,
    nesa_loading: state.nesaregistrationreducer.loading,
    nesa_reg: state.nesaregistrationreducer.reg,
    nesa_levels_loading: state.nesalevelsreducer.loading,
    nesa_levels: state.nesalevelsreducer.levels,
    saflevels_loading: state.saflevelsreducer.loading,
    saflevels: state.saflevelsreducer.levels,
    eagleinfo: state.alumnieagleinforeducer.eagleinfo,
    awardsloading: state.alumniawardsreducer.loading,
    awards: state.alumniawardsreducer.awards,
    scoutings_loading: state.scoutingsreducer.loading,
    scoutings: state.scoutingsreducer.scoutings,
    isspecialist: state.isadminreducer.isspecialist,
    affinities_loading: state.affinitiesreducer.loading,
    affinities: state.affinitiesreducer.affinities,
    localAwards_Loading: state.localAwardsReducer.loading,
    localAwards: state.localAwardsReducer.localAwards,
    privacysettingsOptions: state.alumniPrivacyOptionsreducer.privacysettingsOptions,
    isLoadingPrivacySettings: state.alumniPrivacyOptionsreducer.loading,
    occupationLoading: state.occupationsreducer.loading,
    occupations: state.occupationsreducer.occupations
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default Form.create()(compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AlumniProfile));



// WEBPACK FOOTER //
// ./src/components/AlumniProfile/Index.js